export default __webpack_public_path__ + "static/media/wallet-balance-interest-ico.8858c95e.svg";